import { useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './Dropdown.module.css';

const Dropdown = ({ options, value, onChange, placeholder = 'Select an option...' }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (optionValue) => {
    onChange(optionValue);
    setIsOpen(false);
  };

  return (
    <div className={styles.dropdownWrapper}>
      <motion.div
        className={styles.dropdownHeader}
        onClick={() => setIsOpen((prev) => !prev)}
        whileTap={{ scale: 0.97 }}
        whileHover={{ scale: 1.02 }}
        transition={{ type: 'spring', stiffness: 300, damping: 20 }}
      >
        {value ? options.find((opt) => opt.value === value)?.label : placeholder}
        <FiChevronDown className={`${styles.chevronIcon} ${isOpen ? styles.rotate : ''}`} />
      </motion.div>

      <AnimatePresence>
        {isOpen && (
          <motion.ul
            className={styles.dropdownList}
            initial={{ opacity: 0, y: -5 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -5 }}
            transition={{ duration: 0.25, ease: 'easeOut' }}
          >
            {options.map((option) => (
              <motion.li
                key={option.value}
                className={`${styles.dropdownItem} ${option.value === value ? styles.selected : ''}`}
                whileHover={{ scale: 1.03, backgroundColor: 'rgba(0, 132, 255, 0.15)' }}
                whileTap={{ scale: 0.97 }}
                transition={{ duration: 0.2 }}
                onClick={() => handleSelect(option.value)}
              >
                {option.label}
              </motion.li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Dropdown;